export default "__VITE_ASSET__a07ec1dd__"